// extracted by mini-css-extract-plugin
export default {"item":"downPaymentAttachments_item__MWp7z","view":"downPaymentAttachments_view__yuBXj","attachment":"downPaymentAttachments_attachment__qRGbc"};